import React, { useEffect, useState } from 'react'
import Loading from '../../Loading'
import { postDataCuentasFormasDeLiquidacion, postEliminarCuentasFormasLiquidacion } from '../../../services/Contratacion'
import ModalCrearCuentasFormasDeLiquidacion from './ModalCrearCuentasFormasDeLiquidacion'
import ModalModificarCuentasFormasDeLiquidacion from './ModalModificarCuentasFormasDeLiquidacion'

const ModalCuentasFormasDeLiquidacion = ({setmodalOnCuentas,dataFormaLiquidarYHonorario}) => {
    const [loading,setloading]=useState(false)
    const [dataCuentasFormasDeLiquidacion, setdataCuentasFormasDeLiquidacion]=useState([])
    const [modalOnCrearCuentasFormasLiquidacion, setmodalOnCrearCuentasFormasLiquidacion]=useState(false)
    const [actualizaDataCuentas, setactualizaDataCuentas]=useState([])
    const [dataModificarCuentas, setdataModificarCuentas]=useState([])
    const [modalOnModificarCuentas, setmodalOnModificarCuentas]=useState(false)
    const handleCancelarClick=()=>{
        setmodalOnCuentas(false)
    }
    useEffect(()=>{
        setloading(false)
        postDataCuentasFormasDeLiquidacion(dataFormaLiquidarYHonorario).then((res)=>{
            setloading(true)
            setdataCuentasFormasDeLiquidacion(res.data.data)
        })
    },[actualizaDataCuentas])

    const handleOnclicCrearCuentas=()=>{
        setmodalOnCrearCuentasFormasLiquidacion(true)
    }

    const handleOnclicEliminarCuentas=(data)=>{
      //console.log(data,'datataa')
      const eliminar={
        'ForLiqCod':dataFormaLiquidarYHonorario.ForLiqCod,
        'HnrCod':dataFormaLiquidarYHonorario.HnrCod,
        'ForLqVig':data.ForLqVig,
        'ForLqEmp': data.ForLqEmp
      }
      postEliminarCuentasFormasLiquidacion(eliminar).then((res)=>{
        setactualizaDataCuentas(eliminar)
      })
    }

    const handleOnclicModificarCuentas=(data)=>{
      console.log(data,'dataaaa')
      setdataModificarCuentas(data)
      setmodalOnModificarCuentas(true)
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-full  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Formas Liquidación Cuentas
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            <form >
              <div className="flex py- text-left">
                <div className="w-1/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Forma Liquidación
                  </label>
                  <div className="flex">
                    <input                      
                      defaultValue={dataFormaLiquidarYHonorario.ForLiqCod}
                      disabled={true}
                      type="text"
                      name="codigo"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Código honorario
                  </label>
                  <div className="flex">
                    <input                      
                      defaultValue={dataFormaLiquidarYHonorario.HnrCod}
                      disabled={true}
                      name="descripcion"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    {/* <label className="px-2">Tipo cruento</label>
                    <input
                      
                      name="nombre"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    /> */}
                    
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Nombre honorario
                  </label>
                  <div className="flex">
                    <input
                      disabled={true}
                      defaultValue={dataFormaLiquidarYHonorario.HnrDsc}
                      name="descripcion"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    {/* <label className="px-2">Tipo cruento</label>
                    <input
                      
                      name="nombre"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    /> */}
                    
                  </div>
                </div>
              </div>
              <div className="flex py- text-left p-2">
              <button
                  type="button"
                  onClick={handleOnclicCrearCuentas}
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out "
                >
                  Crear Cuentas Formas Liquidación
                </button>
                </div>
              
                
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-2 inline-block min-w-full sm:px-3 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                          <th></th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Vigencia
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Empresa
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Cuenta contable
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Cuenta Costo
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          dataCuentasFormasDeLiquidacion.map((item, index) => (
                            <tr className=" divide-y divide-slate-700 " key={index}>
                              <td></td>   
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                              <button
                                onClick={()=>handleOnclicEliminarCuentas(item)}
                                type="button"
                                className="inline-block px-2 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
                              >
                                Eliminar
                              </button>
                              </td>
                              <td>
                                <button
                                  onClick={()=>handleOnclicModificarCuentas(item)}
                                  type="button"
                                  className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                                >
                                  Modificar
                                </button>
                              </td>                        
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.ForLqVig}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.ForLqEmp}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.ForCntUVR}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.ForCntCos}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td></td>
                            <td></td>                            
                            <td className="text-center">
                              <Loading /> 
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            {/* <button
                  type="submit"
                  //onClick={handleOnClicGuardarModificacionFormasLiquidacion}
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out "
                >
                  Guardar
                </button>*/}
          </div> 
          </form>
          </div>
        </div>
      </div>
      {modalOnCrearCuentasFormasLiquidacion? <ModalCrearCuentasFormasDeLiquidacion setmodalOnCrearCuentasFormasLiquidacion={setmodalOnCrearCuentasFormasLiquidacion} dataFormaLiquidarYHonorario={dataFormaLiquidarYHonorario} setactualizaDataCuentas={setactualizaDataCuentas}/>:null}
      {modalOnModificarCuentas? <ModalModificarCuentasFormasDeLiquidacion setmodalOnModificarCuentas={setmodalOnModificarCuentas} dataModificarCuentas={dataModificarCuentas} setactualizaDataCuentas={setactualizaDataCuentas}/>:null}
    </div>
  )
}

export default ModalCuentasFormasDeLiquidacion